import { useNavigate } from 'react-router-dom';
import { LogOut, ExternalLink, Menu } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { COMPANY, ADMIN_NAV } from '@/lib/data';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { NavLink } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { cn } from '@/lib/utils';
import { toast } from 'sonner';

export const Topbar = ({ title }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const handleLogout = async () => {
        await logout();
        toast.success('Sesión cerrada');
        navigate('/admin/login');
    };
    return (
        <header data-testid="admin-topbar" className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-border">
            <div className="flex items-center justify-between gap-3 px-4 sm:px-6 h-16">
                <div className="flex items-center gap-2">
                    <Sheet>
                        <SheetTrigger asChild>
                            <button data-testid="admin-mobile-menu-button" className="md:hidden inline-flex items-center justify-center size-10 rounded-lg border border-border text-foreground hover:bg-secondary" aria-label="Menú">
                                <Menu className="size-5" />
                            </button>
                        </SheetTrigger>
                        <SheetContent side="left" className="p-0 w-72">
                            <div className="p-4 border-b border-border">
                                <img src={COMPANY.logo} alt={COMPANY.name} className="h-14 w-14 object-contain" />
                            </div>
                            <nav className="p-2">
                                {ADMIN_NAV.map((item) => {
                                    const Icon = Icons[item.icon] || Icons.Circle;
                                    return (
                                        <NavLink key={item.to} to={item.to} className={({ isActive }) => cn('flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium', isActive ? 'bg-[hsl(var(--kche-cyan))]/10 text-[hsl(var(--kche-cyan))]' : 'text-foreground/80 hover:bg-secondary')}>
                                            <Icon className="size-4" /> {item.label}
                                        </NavLink>
                                    );
                                })}
                            </nav>
                        </SheetContent>
                    </Sheet>
                    <h1 className="font-display text-lg sm:text-xl font-semibold text-foreground">{title}</h1>
                </div>
                <div className="flex items-center gap-2">
                    <a href="/" target="_blank" rel="noreferrer" data-testid="admin-open-site" className="inline-flex items-center gap-2 rounded-lg border border-border px-3 py-1.5 text-sm hover:bg-secondary"><ExternalLink className="size-4" /> <span className="hidden sm:inline">Ver sitio</span></a>
                    <div className="hidden sm:flex items-center gap-3 pl-3 border-l border-border">
                        <div className="text-right text-xs leading-tight">
                            <div className="font-medium">{user?.email}</div>
                            <div className="text-muted-foreground">{user?.role}</div>
                        </div>
                    </div>
                    <button type="button" onClick={handleLogout} data-testid="admin-logout-button" className="inline-flex items-center gap-2 rounded-lg bg-destructive text-destructive-foreground px-3 py-1.5 text-sm font-medium hover:brightness-110"><LogOut className="size-4" /> <span className="hidden sm:inline">Salir</span></button>
                </div>
            </div>
        </header>
    );
};

export default Topbar;
